<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-invoices-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewInvoices',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewInvoicesView: () => import('../components/core/ViewInvoicesView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
